// For full API documentation, including code examples, visit https://wix.to/94BuAAs

import wixUsers from 'wix-users';
import wixLocation from 'wix-location';

$w.onReady(function () {
	//TODO: write your page related code here...

	wixUsers.onLogin( (user) => {
		
		wixLocation.to("/partnersarea");
	} )
});

